import axios from "axios";

const API = axios.create({
  baseURL: "https://exam.skillsuprise.com",
});

export default API;